import { reportError } from '@/datadog/report-error';
import type { ChalkInstance } from 'chalk';
import chalk from 'chalk';

export class Logger {
  prefix: string;
  color: ChalkInstance;
  suppress: boolean;

  constructor(prefix: string, color: ChalkInstance, suppress = false) {
    this.prefix = prefix;
    this.color = color;
    this.suppress = suppress;
  }

  debug(...rest: unknown[]) {
    if (this.suppress) return;
    console.log(
      chalk.blue.bold('[DEBUG]'),
      this.color(`[${this.prefix}]`),
      ...rest
    );
  }

  info(...rest: unknown[]) {
    if (this.suppress) return;
    console.log(
      chalk.cyan.bold('[INFO]'),
      this.color(`[${this.prefix}]`),
      ...rest
    );
  }

  error(...rest: unknown[]) {
    if (this.suppress) return;
    const error = rest.find((value) => value instanceof Error);
    const name =
      typeof rest[0] === 'string' ? `${this.prefix}: ${rest[0]}` : this.prefix;
    reportError(
      name,
      error ?? (rest.length === 1 ? rest[0] : rest),
      error && rest.length > 1 ? { arguments: rest } : undefined
    );
    console.log(
      chalk.red.bold('[ERROR]'),
      this.color(`[${this.prefix}]`),
      ...rest
    );
  }

  warn(...rest: unknown[]) {
    if (this.suppress) return;
    console.log(
      chalk.yellow.bold('[WARN]'),
      this.color(`[${this.prefix}]`),
      ...rest
    );
  }
}
